// Fuel Efficiency Mass units with conversion factors to joule per kilogram (J/kg)
export const fuelEfficiencyMassUnits = [
  { id: 'joule-per-kilogram', name: 'Joule per Kilogram', symbol: 'J/kg', plural: 'Joules per Kilogram', toBase: 1 },
  { id: 'kilojoule-per-kilogram', name: 'Kilojoule per Kilogram', symbol: 'kJ/kg', plural: 'Kilojoules per Kilogram', toBase: 1000 },
  { id: 'calorie-per-gram', name: 'Calorie per Gram', symbol: 'cal/g', plural: 'Calories per Gram', toBase: 4184 },
  { id: 'kilocalorie-per-kilogram', name: 'Kilocalorie per Kilogram', symbol: 'kcal/kg', plural: 'Kilocalories per Kilogram', toBase: 4184 },
  { id: 'btu-per-pound', name: 'BTU per Pound', symbol: 'BTU/lb', plural: 'BTU per Pound', toBase: 2326 },
  { id: 'kilogram-per-joule', name: 'Kilogram per Joule', symbol: 'kg/J', plural: 'Kilograms per Joule', toBase: 0.000001 },
  { id: 'kilogram-per-kilojoule', name: 'Kilogram per Kilojoule', symbol: 'kg/kJ', plural: 'Kilograms per Kilojoule', toBase: 0.001 },
  { id: 'gram-per-calorie', name: 'Gram per Calorie', symbol: 'g/cal', plural: 'Grams per Calorie', toBase: 0.000239006 },
  { id: 'pound-per-btu', name: 'Pound per BTU', symbol: 'lb/BTU', plural: 'Pounds per BTU', toBase: 0.00042986 },
  { id: 'pound-per-horsepower-hour', name: 'Pound per Horsepower-hour', symbol: 'lb/hp·h', plural: 'Pounds per Horsepower-hour', toBase: 0.000000373 },
];

export const popularFuelEfficiencyMassConversions = [
  { from: 'joule-per-kilogram', to: 'kilojoule-per-kilogram' },
  { from: 'kilojoule-per-kilogram', to: 'joule-per-kilogram' },
  { from: 'calorie-per-gram', to: 'kilojoule-per-kilogram' },
  { from: 'kilocalorie-per-kilogram', to: 'joule-per-kilogram' },
  { from: 'btu-per-pound', to: 'kilojoule-per-kilogram' },
  { from: 'joule-per-kilogram', to: 'btu-per-pound' },
];

export const getUnitById = (id) => fuelEfficiencyMassUnits.find(unit => unit.id === id);

export const convertFuelEfficiencyMass = (value, fromId, toId) => {
  const fromUnit = getUnitById(fromId);
  const toUnit = getUnitById(toId);
  if (!fromUnit || !toUnit) return null;
  const baseValue = value * fromUnit.toBase;
  return baseValue / toUnit.toBase;
};

export const formatConversionTitle = (fromUnit, toUnit) => {
  return `Convert ${fromUnit.plural} to ${toUnit.plural}`;
};

export const generateSEODescription = (fromUnit, toUnit) => {
  return `Free online ${fromUnit.name} to ${toUnit.name} converter. Instantly convert fuel efficiency mass units and learn the conversion formula.`;
};
